
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Toyotaetionrentinmumbai() {



    const cardData =
    {
        keyword: ' Toyota Etios on Rent in Mumbai',
        heading: 'Deva Cabs:  Toyota Etios on Rent in Mumbai',
        headingDescription: 'Deva Cabs offers reliable, comfortable, and hassle-free Toyota Etios rentals in Mumbai. Ideal for city travel, airport transfers, and outstation trips, the Toyota Etios provides a perfect balance of space, comfort, and fuel efficiency. Whether you are planning a family outing, business meeting, or a weekend getaway, our well-maintained Etios sedans and experienced drivers ensure a smooth and safe ride. With flexible booking options, affordable rates, and punctual service, Deva Cabs guarantees a convenient and pleasant travel experience with Toyota Etios in Mumbai.',

        top: 'Top Places to Visit in Mumbai with Deva Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "location": "Apollo Bunder, Colaba, Mumbai, Maharashtra",
    "description": "An iconic Indo-Saracenic triumphal arch built in 1924 to commemorate King George V’s visit, and famously where the last British troops left India in 1948. The 26 m basalt structure overlooks the Arabian Sea, serving as a lively gathering spot for ferry rides to Elephanta Island, bhelpuri vendors, and street performers. Sunset vistas and proximity to the Taj Mahal Palace make it a must-see landmark."
  },
  {
    "title": "Marine Drive (Queen’s Necklace)",
    "location": "Churchgate to Nariman Point, South Mumbai, Maharashtra",
    "description": "This 3 km curved boulevard—dubbed the “Queen’s Necklace” for its jewel-like night-time lights—is lined with art‑deco buildings (UNESCO‑listed). A hotspot for evening walks, sea breeze, and street food at Chowpatty Beach. Photo ops abound during sunset as the bay glimmers and the skyline comes alive."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "location": "Fort, Mumbai, Maharashtra",
    "description": "A UNESCO World Heritage site and major transit hub, this Victorian-Gothic marvel built in 1888 features ornate domes, turrets, and stained glass. Packed with history and architecture buffs, it’s also famous for appearances in ‘Slumdog Millionaire’ and is central to Kala Ghoda and Fort heritage walks."
  },
  {
    "title": "Elephanta Caves (Gharapuri Island)",
    "location": "Elephanta Island, Mumbai Harbour, Maharashtra",
    "description": "A UNESCO World Heritage complex of 5th–8th century rock‑cut Hindu caves renowned for the 6 m high Trimurti statue. Accessible via ferry from the Gateway of India (~1 hr ride), the island also offers light snacks, toy‑train rides, and souvenir stalls along the ascent."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya",
    "location": "Fort, Mumbai, Maharashtra",
    "description": "Formerly the Prince of Wales Museum, this grand Indo-Saracenic building houses over 70,000 artifacts, including miniature paintings, Gandharan sculptures, coins, and decorative arts. Nestled amidst Fort’s art galleries and colonial structures, it's perfect for cultural immersion and heritage lovers."
  },
  {
    "title": "Kala Ghoda Art Precinct",
    "location": "Kala Ghoda, Fort, Mumbai, Maharashtra",
    "description": "A vibrant cultural district blanketed with museums (NGMA, Jehangir), galleries, cafés, and boutiques. The annual Kala Ghoda Arts Festival (February) brings street art, performances, workshops and heritage walks — a creative hotspot in South Mumbai."
  },
  {
    "title": "Juhu Beach",
    "location": "Juhu, Mumbai Suburban, Maharashtra",
    "description": "A beloved stretch of sand visited year-round, famous for its vibrant food stalls serving bhelpuri, pani puri, and sev puri. Locals and tourists enjoy evening strolls, fitness sessions, Ganesh Chaturthi celebrations, and occasional plane-spotting due to its proximity to the airport."
  },
  {
    "title": "Dhobi Ghat",
    "location": "Mahalaxmi, Mumbai, Maharashtra",
    "description": "The world’s largest open-air laundry established in 1890. Witness 7,000+ washerfolk (dhobis) hand-washing, pounding, and sun-drying over 100,000 garments daily. A slice of Mumbai’s living heritage—and a compelling documentary-style photo stop."
  },
  {
    "title": "Global Vipassana Pagoda",
    "location": "Gorai Village, Borivali West, Mumbai, Maharashtra",
    "description": "Inspired by Myanmar’s Shwedagon Pagoda, this colossal golden stupa (96 m high) houses Asia’s largest meditation hall seating 8,000. Free 10‑minute Anapana sessions, tranquil lake views, and vegetarian dosas are offered—perfect for mindfulness seekers."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "location": "Bandra to Worli, Mumbai, Maharashtra",
    "description": "A stunning cable-stayed bridge opened in 2009 that connects western suburbs to South Mumbai, featuring sweeping sea views and cityscapes. Drive across by day for sea breezes, or by night for neon-lit panoramas—perfectly framed from nearby Bandra Fort viewpoints."
  },
  {
    "title": "Malabar Hill Elevated Nature Trail",
    "location": "Malabar Hill, South Mumbai, Maharashtra",
    "description": "A recent addition that revives a 12 acre tropical forest with a 482 m elevated walkway and native flora/fauna like kingfishers and parakeets. Ideal for peaceful walks, limiting visitors to preserve its biodiversity, and offering skyline views over Chowpatty."
  }
],



"services": [
    {
        "name": "Toyota Etios on Rent in Mumbai",
        "description": "Rent a Toyota Etios in Mumbai for a smooth, comfortable ride suited for city travel, airport transfers, or outstation trips. Our well-maintained Etios cars come with spacious interiors, air conditioning, and a smooth suspension, making your journey pleasant and hassle-free. Whether you need a cab for a quick city commute or a longer journey, our Toyota Etios rental service guarantees clean vehicles, professional drivers, and competitive pricing."
    },
    {
        "name": "Book Toyota Etios Mumbai",
        "description": "Booking a Toyota Etios cab in Mumbai is now easier than ever with our simple online reservation system. Select your pickup location, travel dates, and preferred time, and confirm your booking within minutes. Our Toyota Etios fleet is regularly serviced, and drivers are background-verified for your safety and comfort. Experience transparent pricing and 24/7 customer support when you book your Etios cab with us."
    },
    {
        "name": "Chauffeur-driven Etios Rental Mumbai",
        "description": "Enjoy a chauffeur-driven Toyota Etios rental in Mumbai, where professionalism meets comfort. Our experienced drivers ensure timely pickups, safe driving, and courteous service, making your ride relaxing and stress-free. Ideal for business trips, airport transfers, or leisure outings, our chauffeur-driven Etios cabs offer privacy, convenience, and exceptional customer care."
    },
    {
        "name": "Affordable Etios Hire Mumbai",
        "description": "Looking for an affordable yet reliable Toyota Etios hire in Mumbai? Our budget-friendly rental options provide excellent value without compromising on comfort or service quality. Perfect for daily commutes, family outings, or small group travel, our affordable Etios cabs come with air conditioning and are driven by professional chauffeurs who prioritize your safety."
    },
    {
        "name": "AC Toyota Etios Cab Mumbai",
        "description": "Beat the Mumbai heat with our air-conditioned Toyota Etios cabs, ensuring a cool and comfortable ride no matter the season. Whether you're traveling across the city or heading for an outstation trip, our AC Etios rental guarantees a refreshing environment and smooth drive. Our cars are regularly cleaned and maintained to meet the highest standards of hygiene and comfort."
    },
    {
        "name": "Toyota Etios for Airport Transfer Mumbai",
        "description": "Make your airport journey seamless with our Toyota Etios cab service for Mumbai’s airports. Our punctual drivers track your flight status to adjust pickups and drop-offs accordingly, minimizing wait times and avoiding traffic hassles. Travel in comfort and style to and from Mumbai’s domestic and international terminals with our reliable Etios airport transfer service."
    },
    {
        "name": "Etios for Outstation Mumbai",
        "description": "Plan your outstation trips from Mumbai with our Toyota Etios rental service designed for long-distance travel. With comfortable seating, ample luggage space, and experienced drivers familiar with highway routes, our Etios cabs offer a stress-free journey to your destination. Whether it’s a weekend getaway or a business trip, travel with confidence and comfort."
    },
    {
        "name": "Sedan Hire Mumbai Toyota Etios",
        "description": "Hire a sedan Toyota Etios in Mumbai for an economical and stylish ride. Our sedans are ideal for solo travelers, couples, or small groups looking for a reliable car with good mileage and comfort. The Toyota Etios sedan is well-suited for city traffic and offers a smooth driving experience with modern amenities to enhance your travel."
    },
    {
        "name": "Etios Rental Mumbai for Family Trip",
        "description": "Travel with your family in our spacious and comfortable Toyota Etios rental in Mumbai. Our family-friendly cabs provide ample legroom and luggage space, making them perfect for weekend outings, holidays, or visits to relatives. Safety and convenience are our priorities, with professional drivers ensuring a pleasant journey for all ages."
    },
    {
        "name": "Etios Cab Mumbai for Corporate Travel",
        "description": "Impress your clients and colleagues with our Toyota Etios cab rental for corporate travel in Mumbai. Our professional drivers provide timely pickups and drop-offs, ensuring your business trips run smoothly. With clean, well-maintained vehicles and flexible booking options, our Etios cabs offer an affordable yet premium transport solution for your corporate needs."
    },
    {
        "name": "Online Toyota Etios Booking Mumbai",
        "description": "Our online booking platform for Toyota Etios rental in Mumbai makes reserving your ride quick and convenient. Choose your pickup location, rental duration, and preferred vehicle with just a few clicks. Receive instant confirmation, transparent pricing, and the option to modify or cancel bookings hassle-free. Enjoy 24/7 customer support throughout your rental period."
    },
    {
        "name": "Long Term Etios Rental Mumbai",
        "description": "Need a car for an extended period? Our long-term Toyota Etios rental service in Mumbai offers flexible packages tailored to your duration and budget. Whether it’s for corporate projects, extended vacations, or personal use, benefit from discounted rates, regular vehicle maintenance, and dedicated customer service when you rent with us long-term."
    },
    {
        "name": "Premium Etios Rental Mumbai",
        "description": "Experience top-tier service with our premium Toyota Etios rental in Mumbai, featuring immaculate cars, professional chauffeurs, and personalized customer care. Ideal for special occasions, VIP clients, or travelers who value comfort and elegance, our premium Etios cabs promise a smooth, luxurious ride with attention to every detail."
    }
],

"tableData": [
    ["Toyota Etios on Rent in Mumbai", "-Book Toyota Etios Mumbai"],
    ["Chauffeur-driven Etios Rental Mumbai", "-Affordable Etios Hire Mumbai"],
    ["AC Toyota Etios Cab Mumbai", "-Toyota Etios for Airport Transfer Mumbai"],
    ["Etios for Outstation Mumbai", "-Sedan Hire Mumbai Toyota Etios"],
    ["Etios Rental Mumbai for Family Trip", "-Etios Cab Mumbai for Corporate Travel"],
    ["Online Toyota Etios Booking Mumbai", "-Long Term Etios Rental Mumbai"],
    ["Premium Etios Rental Mumbai"]
],

whychoose: [
  {
    "WhyChooseheading": "Well-Maintained Toyota Etios Fleet",
    "WhyChoosedescription": "At Deva Cabs, we offer a fleet of clean, well-maintained Toyota Etios cars available for rent in Mumbai. Each vehicle is regularly serviced, sanitized, and inspected for performance—ensuring you enjoy a smooth, reliable ride whether you're heading across town or out of the city."
  },
  {
    "WhyChooseheading": "Perfect for City and Outstation Travel",
    "WhyChoosedescription": "The Toyota Etios is known for its fuel efficiency, spacious interiors, and excellent ride quality—making it ideal for both city commutes and longer journeys outside Mumbai. Whether it's a business trip, family outing, or daily travel, this sedan offers the perfect balance of comfort and performance."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs for a Hassle-Free Experience",
    "WhyChoosedescription": "Our Toyota Etios rentals in Mumbai come with trained, courteous drivers who prioritize your safety and comfort. With deep knowledge of Mumbai’s roads, they ensure timely arrivals and smooth navigation, so you can relax and focus on your schedule without worrying about traffic or directions."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Renting a Toyota Etios in Mumbai with Deva Cabs is budget-friendly and completely transparent. You’ll receive upfront pricing with no hidden charges—what you see is what you pay. Choose from hourly rentals, daily packages, or outstation rates based on your specific needs."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Every Occasion",
    "WhyChoosedescription": "From airport transfers and business meetings to weddings, sightseeing, and weekend getaways, Deva Cabs offers customizable rental packages for the Toyota Etios. Whether you need the car for a few hours, a full day, or multiple days, we have a plan that fits perfectly."
  },
  {
    "WhyChooseheading": "24/7 Booking and Customer Support",
    "WhyChoosedescription": "Need a Toyota Etios at odd hours? No problem. Our booking system is open 24/7 via mobile app, website, or helpline. Plus, our customer support team is always available to help with bookings, rescheduling, or special travel requests—even at the last minute."
  },
  {
    "WhyChooseheading": "Safety-First Rental Service",
    "WhyChoosedescription": "Every Toyota Etios in our fleet comes equipped with essential safety features like seat belts, ABS, airbags, and GPS tracking. Our drivers are background-verified, and each vehicle undergoes rigorous safety checks—so you can travel with complete peace of mind."
  },
  {
    "WhyChooseheading": "Punctual and Professional Service Every Time",
    "WhyChoosedescription": "At Deva Cabs, we pride ourselves on professionalism and punctuality. When you book a Toyota Etios rental in Mumbai, expect on-time pickups, well-dressed drivers, and a service experience that reflects our commitment to quality and customer satisfaction."
  }
]











    }




const faqData = [
  {
    question: "Can I rent a Toyota Etios in Mumbai with Deva Cabs?",
    answer: "Yes, Deva Cabs offers Toyota Etios on rent in Mumbai. You can easily book the vehicle via our website, mobile app, or by contacting customer support."
  },
  {
    question: "What is the rental fare for a Toyota Etios in Mumbai?",
    answer: "The rental fare for a Toyota Etios in Mumbai depends on the duration of the rental and the type of service. You can check the exact fare using our website or mobile app or get in touch with our customer support."
  },
  {
    question: "Is the Toyota Etios available for both one-way and round-trip rentals?",
    answer: "Yes, you can rent a Toyota Etios for both one-way and round-trip services in Mumbai. We offer flexible rental options to suit your needs."
  },
  {
    question: "Are there any special offers or discounts on renting a Toyota Etios in Mumbai?",
    answer: "We often have special offers and discounts on car rentals, including the Toyota Etios. Check our website or app for the latest deals and promotions."
  },
  {
    question: "What are the payment options for renting a Toyota Etios in Mumbai?",
    answer: "We accept various payment options, including cash, credit/debit cards, UPI, and online payments via our mobile app or website."
  },
  {
    question: "Can I pre-schedule the rental of a Toyota Etios in Mumbai?",
    answer: "Yes, you can pre-schedule your Toyota Etios rental in Mumbai through our booking portal or mobile app. Select your preferred date and time for guaranteed availability."
  },
  {
    question: "Is the Toyota Etios in good condition?",
    answer: "Absolutely! We ensure that all our rental cars, including the Toyota Etios, are regularly maintained, clean, and in excellent condition for your comfort and safety."
  },
  {
    question: "Can I hire a driver with the Toyota Etios rental in Mumbai?",
    answer: "Yes, you can hire a professional driver with the Toyota Etios rental. All our drivers are experienced and familiar with Mumbai's roads to ensure a safe and smooth journey."
  }
];

const testimonialData = [
  {
    id: 1,
    name: 'Mr. Arvind Patel',
    role: 'Business Traveler',
    review: 'I rented a Toyota Etios from Deva Cabs for a business trip in Mumbai. The car was in excellent condition, and the driver was punctual and professional. I had a smooth and comfortable experience.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 2,
    name: 'Ms. Neha Agarwal',
    role: 'Tourist',
    review: 'Rented a Toyota Etios for a trip around Mumbai with Deva Cabs. The car was clean, spacious, and the driver was very helpful. Highly recommended for anyone looking for a reliable car rental!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Toyota Etios on Rent in Mumbai",
  "image": "https://devacab.com/assets/images/toyota-etios-on-rent-in-mumbai.jpg", // Replace with actual image URL
  "description": "Rent a Toyota Etios in Mumbai with Deva Cabs. Affordable chauffeur-driven sedan ideal for airport transfers, city rides, outstation trips, family travel, and corporate use. Clean AC cars with professional drivers. Book online today.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1499", // Example starting price, update as needed
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/toyota-etios-on-rent-in-mumbai" // Replace with actual page URL
  }
};







    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Toyota Etios on Rent in Mumbai | Book Etios Sedan with Driver | Deva Cabs</title>
  <meta
    name="description"
    content="Book Toyota Etios on rent in Mumbai with Deva Cabs. AC sedan with driver for airport transfers, outstation, corporate travel, and family trips. Affordable, clean, and comfortable Toyota Etios cab service."
  />
  <meta
    name="keywords"
    content="Toyota Etios on Rent in Mumbai, Book Toyota Etios Mumbai, Chauffeur-driven Etios rental Mumbai, Affordable Etios hire Mumbai, AC Toyota Etios cab Mumbai, Toyota Etios for airport transfer Mumbai, Etios for outstation Mumbai, Sedan hire Mumbai Toyota Etios, Etios rental Mumbai for family trip, Etios cab Mumbai for corporate travel, Online Toyota Etios booking Mumbai, Long term Etios rental Mumbai, Premium Etios rental Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/52.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Toyotaetionrentinmumbai;